module.exports = __webpack_public_path__ + "static/media/levelin.31c02c3a.png";